import qs from 'query-string';
import { intercepter, mock } from '../config';
import { TTheme } from '../../api/theme';

const data: TTheme[] = [
    {
        id: 1,
        name: 'Purple Theme',
        value: 'purple',
        config: {
            fontFamily: 'Inter, sans-serif',
            colorPrimary: '#088947',
            colorSecondary: '#5FB33C',
        },
    },
    {
        id: 2,
        name: 'Magenta Theme',
        value: 'magenta',
        config: {
            fontFamily: 'Inter, sans-serif',
            colorPrimary: '#FF57A6',
            colorSecondary: '#FF8C73',
        },
    },
    {
        id: 3,
        name: 'Green Theme',
        value: 'green',
        config: {
            fontFamily: 'Inter, sans-serif',
            colorPrimary: '#4DCC8F',
            colorSecondary: '#5FB33C',
        },
    },
    {
        id: 4,
        name: 'Golden Theme',
        value: 'golden',
        config: {
            fontFamily: 'Inter, sans-serif',
            colorPrimary: '#4DCC8F',
            colorSecondary: '#5FB33C',
        },
    },
    {
        id: 5,
        name: 'Red Theme',
        value: 'red',
        config: {
            fontFamily: 'Inter, sans-serif',
            colorPrimary: '#b01139',
            colorSecondary: '#780725',
        },
    },
];

mock.mock(/\/theme\/list\/mock*/, 'get', (config: any) => {
    const jsonParams = config.url.split('?')[1];
    const params = qs.parse(jsonParams);

    return intercepter(data, params);
});
